// src/components/TopSellingProducts/TopSellingProducts.js

import React, { useCallback, useEffect, useState } from "react";
import "./TopSellingProducts.css";
import Icons from "../../../../Config/Images";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addWishlistAPI } from "../../../../Store/Action/wishlistAction";
import { toast } from "react-toastify";
import { addToCartAPI } from "../../../../Store/Action/cartAction";
import ProductCard from "../../CustomComponents/ProductCard"; // Import your custom ProductCard
import { useCalendarState } from "@mui/x-date-pickers/internals";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";

const TopSellingProducts = ({ data, onFetchGetWishlist, userRole }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [topSellingProducts, setTopSellingProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  // const [userRole, setUserRole] = useState("");
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled
  );
  // const [isWastageEnabled, setIsWastageEnabled] = useState(true);
  // useEffect(() => {
  //   dispatch(
  //     getLoggedInUserDetailsAPI({}, (result) => {
  //       // setUserRole(result?.data?.[0]?.user_role_name);
  //       const booleanValue =
  //         result?.data?.[0]?.user_generic_data_value?.[0]
  //           ?.user_generic_data_boolean_value;

  //       if (typeof booleanValue === "boolean") {
  //         setIsWastageEnabled(booleanValue);
  //       } else if (booleanValue === 0 || booleanValue === 1) {
  //         setIsWastageEnabled(booleanValue === 1);
  //       }
  //     })
  //   );
  // }, [dispatch]);
  useEffect(() => {
    // setIsLoading(true); // Start loading
    if (data) {
      setTopSellingProducts(data);
      // setIsLoading(false); // Stop loading
    }
  }, [data]);

  // const handleViewAllClick = () => {
  //   navigate("/all-product-listing", { state: "fromTopSellingProducts" });
  // };
  const handleViewAllClick = () => {
    navigate("/top-selling-products", { state: "fromTopSellingProducts" });
  };

  const handleProductClick = (productId) => {
    navigate(`/productDetail/${productId}`, { state: { productId } });
  };
  // useEffect(() => {
  //   dispatch(
  //     getLoggedInUserDetailsAPI({}, (result) => {
  //       setUserRole(result?.data?.[0]?.user_role_name);
  //     })
  //   );
  // }, [dispatch]);

  // const handleWishlistClick = (prod) => {
  //   const userRequestData = { product_id: prod.product_id };
  //   dispatch(
  //     addWishlistAPI(userRequestData, (result) => {
  //
  //       if (result?.data?.status) {
  //         toast.success(result?.data?.message?.message);
  //       } else {
  //         toast.error(result?.data?.error?.message);
  //       }
  //     })
  //   );
  // };

  // const handleAddToCartClick = (prod) => {
  //   const cartData = { product_id: prod.product_id, product_quantity: 1 };
  //   dispatch(
  //     addToCartAPI(cartData, (result) => {
  //
  //       if (result?.data?.status) {
  //         toast.success("Product added to cart!");
  //       } else {
  //         toast.error("Failed to add product to cart.");
  //       }
  //     })
  //   );
  // };

  return (
    <div className="topSellingProductsDiv uniqueTopSellDiv">
      <div className="upperContent">
        <h1>Top Selling Products</h1>
        <p>Shop our most popular products, loved by customers</p>
      </div>

      <div className="lowerContent">
        <div className="hrLine" />
        <div className="view-all">
          {topSellingProducts.length > 0 && (
            <>
              <p
                onClick={handleViewAllClick}
                style={{ display: "inline-block" }}
              >
                View all
              </p>
            </>
          )}
        </div>
        <div className="cardsMainDiv">
          {isLoading ? (
            <p>Loading...</p>
          ) : topSellingProducts.length > 0 ? (
            topSellingProducts?.map((prod, index) => (
              <ProductCard
                key={index}
                image={`${prod?.product_image?.product_image_url}`}
                // title={prod.product_name || "No Title"}
                // title={
                //   prod?.product_subCategory_name
                //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                //     : `${prod?.product_name}`
                // }
                title={
                  prod?.product_name
                    ? prod?.product_name
                    : `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                }
                netWeight={prod.product_net_weight || "N/A"}
                // productCode= {prod.prodct_code}
                wastage={prod.product_wastage}
                fine={
                  userRole.toLowerCase() === "retailer"
                    ? prod.product_retailer_per_pcs_fine
                    : userRole.toLowerCase() === "wholesaler"
                    ? prod.product_whole_seller_per_pcs_fine
                    : "N/A"
                }
                product={prod}
                isWishlist={prod.wishlist_id}
                onGetWishlistProduct={onFetchGetWishlist}
                flagCart={prod?.flag_cart}
                userRole={userRole}
                isWastageEnabled={isWastageEnabled}
              />
            ))
          ) : (
            <p>No top-selling products available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopSellingProducts;
